/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Messages/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import All from './All/index'
import No from './No/index'
import React from 'react'
import Unread from './Unread/index'



/** @type {import('Simple/types.js').View} */
export default function Messages({
  children,
  viewPath = "/App/Account/Topbar/Inbox/Content/Content/Messages"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let selectedInboxTabIdValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'inbox_tab_id',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: selectedInboxTabIdValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Unread'}>
<Unread
  viewPath={`${viewPath}/Unread`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'All'}>
<All
  viewPath={`${viewPath}/All`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}